<template>
  <div>
    <h1>Key Handling</h1>
    <ul>
      {{
        events
      }}
      <li v-for="(event, index) of events" :key="'event-' + index">
        KeyCode: {{ event.keyCode }} <br />
        Code: {{ event.code }} <br />
        Name: {{ event.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  emits: {},
  data() {
    return {
      events: [],
    };
  },
  mounted() {
    document.addEventListener('keydown', this.handleEvent);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleEvent);
  },
  methods: {
    handleEvent(event) {
      this.events.push(event);
    },
  },
  computed: {},
  watch: {},
  // created: function() {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/InfoKeyHandling.vue